module.exports = __webpack_public_path__ + "static/media/order_voucher.4406d0f2.svg";